import { render, staticRenderFns } from "./selectOther.vue?vue&type=template&id=1bc7220f&scoped=true&"
import script from "./selectOther.vue?vue&type=script&lang=js&"
export * from "./selectOther.vue?vue&type=script&lang=js&"
import style0 from "./selectOther.vue?vue&type=style&index=0&id=1bc7220f&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bc7220f",
  null
  
)

export default component.exports